import type { ReactNode } from 'react';
import { BrandMark } from '../common';

// The global top bar (app-shell-redesign AC1). A composable frame: it owns the
// fixed chrome — the brand landmark (static, not clickable) — and slots the
// variable pieces (search, the contextual date picker, the New/bell actions) so
// each is built once and dropped in. Scroll-shrink is driven by the `shrunk`
// flag from AppShell.
//
// THE ☰ IS GONE, not disabled (docs/decision/sidebar-always-collapsed.md). The
// rail can no longer be expanded, and a toggle that toggles nothing is worse
// than no toggle. Everything to its right shifts left into the 44px it held;
// the paw and the wordmark are not restyled, resized or relocated — they simply
// start further left, and the search cap rises by exactly what was returned.

export interface TopBarProps {
  /** true once the content has scrolled — collapses the tagline + logo + height. */
  shrunk?: boolean;
  search?: ReactNode;
  /** centre slot — the contextual date picker. */
  center?: ReactNode;
  /** right slot — the New menu + notification bell. */
  actions?: ReactNode;
}

export function TopBar({ shrunk = false, search, center, actions }: TopBarProps) {
  return (
    <header className={'topbar' + (shrunk ? ' tb-shrunk' : '')}>
      <div className="tb-left">
        <div className="tb-brand">
          <BrandMark size={shrunk ? 30 : 36} />
          <div className="tb-bt">
            <div className="tb-bn">Beeches Brook</div>
            <div className="tb-bg">Boarding Kennels</div>
          </div>
        </div>
        {search}
      </div>
      <div className="tb-center">{center}</div>
      <div className="tb-right">{actions}</div>
    </header>
  );
}
